export const addEditPlanTranslation = {
  en: {
    "Add Plans": "Add Plans",
    "Edit Plans": "Edit Plans",
    "Plans name (En)": "Plans name (En)",
    "Plans name (Ar)": "Plans name (Ar)",
    "Description (En)": "Description (En)",
    "Description (Ar)": "Description (Ar)",
    "Price Monthly": "Price Monthly",
    "Price Yearly": "Price Yearly",
    "Recommended": "Recommended",
    "Status": "Status",
    "Add Features for Plans": "Add Features for Plans",
    "Add Feature": "Add Feature",
    "Submit": "Submit",
    "Save": "Save",
    "Select Feature": "Select Feature",
    "Is Boolean": "Is Boolean",
    "Feature Value": "Feature Value",
    "Edit Feature": "Edit Feature",
    "Feature Availability": "Feature Availability",
    "Edit Values for Features": "Edit Values for Features",
    "True": "True",
    "False": "False",
    "Active": "Active",
    "Inactive": "Inactive",
    "Enter First Name": "Enter First Name",
    "Enter Second Name": "Enter Second Name",
    "Enter Monthly Price": "Enter Monthly Price",
    "Enter Yearly Price": "Enter Yearly Price",
    "Enter English value": "Enter English value",
    "Enter Arabic value": "Enter Arabic value",
    "Home": "Home",
    "Plans & Features": "Plans & Features",
    "Plans": "Plans",
    "Unknown Feature": "Unknown Feature",
    "Plan added successfully": "Plan added successfully",
    "Failed to add plan": "Failed to add plan",
    "S.No": "S.No",
    "Feature": "Feature",
    "Values": "Values",
    "Action": "Action",
  },
  ar: {
    "Add Plans": "إضافة خطط",
    "Edit Plans": "تحرير الخطط",
    "Plans name (En)": "اسم الخطة (En)",
    "Plans name (Ar)": "اسم الخطة (Ar)",
    "Description (En)": "الوصف (En)",
    "Description (Ar)": "الوصف (Ar)",
    "Price Monthly": "السعر الشهري",
    "Price Yearly": "السعر السنوي",
    "Recommended": "موصى به",
    "Status": "الحالة",
    "Add Features for Plans": "إضافة ميزات للخطة",
    "Add Feature": "إضافة ميزة",
    "Submit": "إرسال",
    "Save": "حفظ",
    "Select Feature": "اختر ميزة",
    "Is Boolean": "هل هو منطقي",
    "Feature Value": "قيمة الميزة",
    "Edit Feature": "تحرير الميزة",
    "Feature Availability": "توفر الميزة",
    "Edit Values for Features": "تحرير القيم للميزات",
    "True": "نعم",
    "False": "لا",
    "Active": "نشط",
    "Inactive": "غير نشط",
    "Enter First Name": "أدخل الاسم الأول",
    "Enter Second Name": "أدخل الاسم الثاني",
    "Enter Monthly Price": "أدخل السعر الشهري",
    "Enter Yearly Price": "أدخل السعر السنوي",
    "Enter English value": "أدخل القيمة الإنجليزية",
    "Enter Arabic value": "أدخل القيمة العربية",
    "Home": "الصفحة الرئيسية",
    "Plans & Features": "الخطط والميزات",
    "Plans": "الخطط",
    "Unknown Feature": "ميزة غير معروفة",
    "Plan added successfully": "تمت إضافة الخطة بنجاح",
    "Failed to add plan": "فشل في إضافة الخطة",
    "S.No": "رقم",
    "Feature": "ميزة",
    "Values": "القيم",
    "Action": "الإجراء",
  },
};
